export const declinations = (num, text) => {
  num = Math.abs(num) % 100
  const n1 = num % 10
  if (num > 10 && num < 20) { return text[2] }
  if (n1 > 1 && n1 < 5) { return text[1] }
  if (n1 === 1) { return text[0] }
  return text[2]
}
